// 112px [Pricing specific]
export const fontSize_2lgheadings = `xs:text-[35px] sm:text-[40px]  md:text-[50px] lg:text-[50px] xl:text-[60px]  2xl:text-[60px]`;

// 90px
export const fontSize_headings = `xs:text-[20px] sm:text-[30px]  md:text-[40px] lg:text-[50px] xl:text-[50px]  2xl:text-[50px]`;

// 30px
export const fontSize_headerTitles = `xs:text-[12px] sm:text-[15px]`;

// 35Px
export const fontSize_headerTitles35 = `xs:text-[12px] sm:text-[15px]  md:text-[20px] lg:text-[22px] xl:text-[25px]  2xl:text-[30px]`;
//60px
export const fontSize_CardHeaders60 = `xs:text-[25px] sm:text-[30px] md:text-[35px] md:leading-[45px] sm:leading-[40px] xs:leading-[35px]`;
// 50px
export const fontSize_CardHeaders = `xs:text-[25px] sm:text-[30px]  md:text-[35px] lg:text-[40px] xl:text-[40px]  2xl:text-[40px]`;

// 25px
export const fontSize_detail25 = `xs:text-[10px] sm:text-[10px]  md:text-[15px] lg:text-[14px] xl:text-[14px]  2xl:text-[14px]`;

export const fontSize_32 = `xs:text-[16px] sm:text-[20px]  md:text-[22px]`;
export const fontSize_20 = `xs:text-[16px] sm:text-[20px]  md:text-[20px]`;
export const fontSize_22 = `xs:text-[12px] sm:text-[14px]  md:text-[16px]`;
export const fontSize_15 = `xs:text-[12px] sm:text-[14px]  md:text-[15px]`;

// maxwidth
export const maxWidth = `max-w-[1280px]`;

// cards [400]

// export const font

export const fontSize_lendings = `xs:leading-[25px] sm:leading-[40px]  md:leading-[50px] lg:leading-[65px] xl:leading-[65px]  2xl:leading-[65px]`;

export const buttonConfig = ` ${fontSize_detail25} xs:px-4 xs:py-1 sm:px-8 sm:py-2 md:px-8 md:py-3 font-semibold `;

// Grid
export const gridConfig = ` grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-3  mx-4`;
export const gridPricingConfig = ` grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-3  md:mx-12 lg:mx-1 xl:mx-4`;
